import dayjs from 'dayjs'

export const formatDate = (value: Date): String =>
  dayjs(value).format('YYYY-MM-DD HH:mm:ss [Z]')
